import { CustomModal } from './styles';

import Icon from '@map/components/Icons';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import { useState, useEffect } from 'react';
/**
 * Importação da biblioteca Draggable que da permissão
 * a componentes serem arrastados pela interface do usuario.
 */
import Draggable from 'react-draggable';

/**
 * SimpleModal
 * 
 * @param {string} title
 * @param {object} customHeader
 * @param {*} children
 * @param {*} open
 * @param {function} onClose
 * @param {boolean} closeButton
 * @param {function} draggable
 * @param {number} relativePosition
 * @param {number} zIndex
 * 
 * @returns 
 */
const SimpleModal = ({
  title,
  customHeader,
  children,
  open,
  onClose,
  closeButton = true,
  draggable,
  relativePosition,
  viewWidth,
  zIndex,
}) => {
  const [positionX, setPositionX] = useState(0);
  const [positionY, setPositionY] = useState(0);

  useEffect(() => {
    if (relativePosition?.x !== null) setPositionX(relativePosition?.x);
    if (relativePosition?.y !== null) setPositionY(relativePosition?.y);
  }, [relativePosition]);

  return open ? (
    <ClickAwayListener onClickAway={() => onClose('clickAway')}>
      <Draggable
        position={{ x: positionX, y: positionY }}
        onStop={(_, { x, y }) => {
          setPositionX(x);
          setPositionY(y);
        }}
        disabled={draggable === false ? true : false}
        cancel=".body"
      >        
        <CustomModal 
          className="modal" 
          zIndex={zIndex} 
          viewWidth={viewWidth}>
          <Paper>
            {closeButton && (
              <button className="close_bt" onClick={onClose}>
                <Icon i="map-close" />
              </button>
            )}
            {customHeader ? (
              customHeader
            ) : (
              <div className="header">
                <h3>{title}</h3>
              </div>
            )}
            <div className="body">{children}</div>
          </Paper>
        </CustomModal>        
      </Draggable>
    </ClickAwayListener>
  ) : null;
};

SimpleModal.properties = {
  ignore: true,
};

export default SimpleModal;
